import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { formatTime } from "../../../../utils";
import { FlexRowSpaced } from "../../Styles";
import VideoPlayerProps from "../VideoPlayer";

const TitleDescription = (props: VideoPlayerProps.TitleDescriptionProps) => {
  const { typography, Color } = useTheme();
  const { currentTime, video_description, video_title, duration } = props;

  return (
    <>
      <Components.Text
        text={video_title}
        style={{ tokenStyle: typography.Heading.M }}
        color={Color.icon["icon-inverse"].value}
        maxLineLength={1}
        lineHeight={"line-height-300"}
      />
      <DescriptionTimerContainer>
        <Components.Text
          text={video_description}
          style={{ tokenStyle: typography.Heading.XS }}
          color={"#BBBBBB"}
          maxLineLength={1}
          fontWeight="font-weight-light"
        />
        <div>
          <Components.Text
            text={`${formatTime(currentTime)} / ${formatTime(duration)}`}
            style={{ tokenStyle: typography.Heading.XS }}
            color={Color.icon["icon-inverse"].value}
            renderInSingleLine
            fontWeight="font-weight-light"
            lineHeight={"line-height-50"}
          />
        </div>
      </DescriptionTimerContainer>
    </>
  );
};

export default TitleDescription;

export const DescriptionTimerContainer = styled(FlexRowSpaced)`
  align-items: end;
`;
